import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/PMS/customerService/lostAndFound/goodsType';
export default {
  props: {
    showDialog: Boolean,
    isCheck: Boolean,
    isUpdateGoods: Boolean,
    goodsInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      rules: {
        goodsName: [{
          required: true,
          message: '请输入物品名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        goodsType: [{
          required: true,
          message: '请选择物品类型',
          trigger: 'change'
        }],
        goodsSpecial: [{
          required: true,
          message: '请输入物品特点',
          trigger: 'change'
        }]
      },
      typeOptions: [],
      files: [],
      uploadUrl: '',
      downloadUrl: '',
      addList: [],
      uploadList: [],
      dialogImageUrl: '',
      picUrl: '',
      imageUrl: '',
      dialogVisible: false,
      fileList: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
    this.getGoodsType();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.fileList = [];
      this.files = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (Object.keys(this.goodsInfo).length > 0) {
        this.childData = this.goodsInfo;

        if (this.goodsInfo.photoList) {
          this.files = this.goodsInfo.photoList.map(function (item) {
            return {
              fileId: item.fileId,
              url: item.fileId,
              name: item.fileName
            };
          });
        }

        this.fileList = this.files;
        console.log(this.fileList, 'ggggg'); // this.dialogImageUrl = 'https://ppp222.goho.co/pic/2023/4/19/d04819ba9df24bf7b988eb3b154647cc.jpg'
      } else {
        this.childData = {};
      }
    },
    getGoodsType: function getGoodsType() {
      var _this2 = this;

      fetchList({
        page: 1
      }).then(function (res) {
        _this2.typeOptions = res.data.data;
      });
    },
    handleGoodsType: function handleGoodsType(id) {
      var goods = this.typeOptions.find(function (item) {
        return item.dicValue === id;
      });
      this.$set(this.childData, 'goodsTypeValue', goods.typeName);
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this3.childData.photoList = _this3.fileList;

          _this3.$emit('transferGoodsObj', _this3.childData, _this3.isUpdateGoods);
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairAdd');
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        fileId: file.response.data[0].fileId,
        url: file.response.data[0].fileId,
        fileName: response.data[0].fileName,
        name: response.data[0].fileName
      });
    },
    handleError: function handleError(err, file) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handleExceed: function handleExceed() {},
    handlePreview: function handlePreview(file) {
      console.log('file', file);

      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        this.dialogImageUrl = file.url;

        if (file.filePath !== undefined) {
          file.url = file.filePath;
        }

        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var isJPEG = file.type === 'image/jpeg';
      var isJPG = file.type === 'image/jpg';
      var isPNG = file.type === 'image/png';

      if (!(isJPEG || isPNG || isJPG)) {
        this.$message.error('上传图片只能是 JPG/JPEG/PNG 格式!');
      }

      return isJPG || isJPEG || isPNG; // const isLt2M = file.size / 1024 / 1024 < 10
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 10MB!',
      //     type: 'error'
      //   })
      //   return false
      // }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this4 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this4.fileList.splice(index, 1);
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};